export enum EFormaCp {
    _1 = '1',
    _3 = '3',
    C = 'C',
    _4 = '4'
}
